import Image from 'next/image';

interface LoaderProps {
  text?: string;
  compact?: boolean;
  size?: number;
}

export function Loader({ text, compact = false, size }: LoaderProps) {
  const imageWidth = size ?? (compact ? 120 : 170);
  const imageHeight = size ?? (compact ? 54 : 54);

  return (
    <div>
      {text && <p className="text-sm text-gray-400 text-center py-6">{text}</p>}
      <div className={`flex justify-center ${compact ? 'mb-auto' : 'mb-14'}`}>
        <Image
          src="/assets/svgs/Logo_CJRRenewables_animated.svg"
          alt="CJR Renewables"
          width={imageWidth}
          height={imageHeight}
          priority
        />
      </div>
    </div>
  );
}
